import { authApiSlice } from "./authApiSlice";

export const communicationApiSlice = authApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTimelineFeed: builder.query({
      query: ({ page = 1, per_page = 10, scope, classroom_id } = {}) => ({
        url: "/timeline/feed",
        params: {
          page,
          per_page,
          ...(scope ? { scope } : {}),
          ...(classroom_id ? { classroom_id } : {}),
        },
      }),
      providesTags: ["Timeline"],
    }),
    createTimelinePost: builder.mutation({
      query: (body) => ({
        url: "/timeline/posts",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Timeline"],
    }),
    addTimelineComment: builder.mutation({
      query: ({ postId, body, mediaUrls }) => ({
        url: `/timeline/posts/${postId}/comments`,
        method: "POST",
        body: { body, ...(mediaUrls?.length ? { media_urls: mediaUrls } : {}) },
      }),
      invalidatesTags: ["Timeline"],
    }),
    addTimelineReaction: builder.mutation({
      query: ({ postId, emoji }) => ({
        url: `/timeline/posts/${postId}/reactions`,
        method: "POST",
        body: { emoji },
      }),
      invalidatesTags: ["Timeline"],
    }),
    removeTimelineReaction: builder.mutation({
      query: ({ postId, emoji }) => ({
        url: `/timeline/posts/${postId}/reactions/${encodeURIComponent(emoji)}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Timeline"],
    }),
    getChatConversations: builder.query({
      query: () => "/chat/conversations",
      providesTags: ["Chat"],
    }),
    createChatConversation: builder.mutation({
      query: (body) => ({
        url: "/chat/conversations",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Chat"],
    }),
    getChatMessages: builder.query({
      query: ({ conversationId, page = 1, per_page = 50 }) => ({
        url: `/chat/conversations/${conversationId}/messages`,
        params: { page, per_page },
      }),
      providesTags: (_result, _error, { conversationId }) => [{ type: "Chat", id: conversationId }],
    }),
    sendChatMessage: builder.mutation({
      query: ({ conversationId, body, data }) => ({
        url: `/chat/conversations/${conversationId}/messages`,
        method: "POST",
        body: { body, ...(data ? { data } : {}) },
      }),
      invalidatesTags: (_result, _error, { conversationId }) => ["Chat", { type: "Chat", id: conversationId }],
    }),
    markConversationRead: builder.mutation({
      query: (conversationId) => ({
        url: `/chat/conversations/${conversationId}/read`,
        method: "PATCH",
      }),
      invalidatesTags: ["Chat"],
    }),
    getNotificationPreferences: builder.query({
      query: () => "/notification/preferences",
      providesTags: ["NotificationPreferences"],
    }),
    updateNotificationPreferences: builder.mutation({
      query: (preferences) => ({
        url: "/notification/preferences",
        method: "PATCH",
        body: { preferences },
      }),
      invalidatesTags: ["NotificationPreferences"],
    }),
    getVapidPublicKey: builder.query({
      query: () => "/notification/web-push/vapid-public-key",
    }),
    subscribeWebPush: builder.mutation({
      query: (body) => ({
        url: "/notification/web-push/subscribe",
        method: "POST",
        body,
      }),
    }),
    unsubscribeWebPush: builder.mutation({
      query: (body) => ({
        url: "/notification/web-push/subscribe",
        method: "DELETE",
        body,
      }),
    }),
  }),
});

export const {
  useGetTimelineFeedQuery,
  useCreateTimelinePostMutation,
  useAddTimelineCommentMutation,
  useAddTimelineReactionMutation,
  useRemoveTimelineReactionMutation,
  useGetChatConversationsQuery,
  useCreateChatConversationMutation,
  useGetChatMessagesQuery,
  useSendChatMessageMutation,
  useMarkConversationReadMutation,
  useGetNotificationPreferencesQuery,
  useUpdateNotificationPreferencesMutation,
  useGetVapidPublicKeyQuery,
  useSubscribeWebPushMutation,
  useUnsubscribeWebPushMutation,
} = communicationApiSlice;
